import { render, staticRenderFns } from "./slideregion3.vue?vue&type=template&id=71a1671c&"
import script from "./slideregion3.vue?vue&type=script&lang=js&"
export * from "./slideregion3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports